export default __webpack_public_path__ + "static/media/elevate-cbb-3.274dab78.png";